import { useLocation, useNavigate } from "react-router-dom";
import { useBetween } from "use-between";
import { useAuthApi } from "../../pages/useApi";

import "./index.scss";
import { useEffect } from "react";
import PropTypes from "prop-types";

const Navbar = ({ active }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAdmin, logout, multipleCustomers } = useBetween(useAuthApi);

    const handleLogout = () => {
        logout().then(() => {
            navigate("/");
        });
    };

    const activeFromPath = (() => {
        const pathname = location.pathname || "";
        if (pathname.startsWith("/profile/representative")) return "representative";
        if (pathname.startsWith("/profile/details")) return "details";
        if (pathname.startsWith("/profile/password")) return "password";
        if (pathname.startsWith("/profile/orders")) return "orders";
        if (pathname.startsWith("/profile/privacy")) return "privacy";
        if (pathname.startsWith("/profile/data")) return "data";
        if (pathname.startsWith("/profile/open-invoices")) return "open-invoice";
        if (pathname.startsWith("/profile/contents")) return "content";
        if (pathname.startsWith("/profile/delivery")) return "delivery";
        return null;
    })();

    const resolvedActive = activeFromPath || active;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            className={`navbar-container ${multipleCustomers ? "hasMultipleCustomers" : ""
                }`}
        >
            <h3>Account</h3>
            <ul>
                <li className={`${resolvedActive === "details" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "details" ? "page" : undefined}
                        onClick={() => navigate("/profile/details")}
                    >
                        Details
                    </button>
                </li>
                <li className={`${resolvedActive === "representative" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "representative" ? "page" : undefined}
                        onClick={() => navigate("/profile/representative")}
                    >
                        Representative
                    </button>
                </li>
                <li className={`${resolvedActive === "password" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "password" ? "page" : undefined}
                        onClick={() => navigate("/profile/password")}
                    >
                        Password
                    </button>
                </li>
                {/* <li
                    className={`${active === "favorites" ? "active" : ""}`}
                    onClick={() => navigate("/profile/favorites")}
                >
                    Favorites
                </li> */}
                <li className={`${resolvedActive === "orders" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "orders" ? "page" : undefined}
                        onClick={() => navigate("/profile/orders")}
                    >
                        Orders
                    </button>
                </li>
                <li className={`${resolvedActive === "privacy" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "privacy" ? "page" : undefined}
                        onClick={() => navigate("/profile/privacy")}
                    >
                        Privacy
                    </button>
                </li>
                <li className={`${resolvedActive === "data" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "data" ? "page" : undefined}
                        onClick={() => navigate("/profile/data")}
                    >
                        Data
                    </button>
                </li>
                <li className={`${resolvedActive === "open-invoice" ? "active" : ""}`}>
                    <button
                        type="button"
                        className="navbar-item"
                        aria-current={resolvedActive === "open-invoice" ? "page" : undefined}
                        onClick={() => navigate("/profile/open-invoices")}
                    >
                        Open Invoices
                    </button>
                </li>
                {isAdmin === true ? (
                    <>
                        <li className={`${resolvedActive === "content" ? "active" : ""}`}>
                            <button
                                type="button"
                                className="navbar-item"
                                aria-current={resolvedActive === "content" ? "page" : undefined}
                                onClick={() => navigate("/profile/contents")}
                            >
                                Content Management
                            </button>
                        </li>
                        <li className={`${resolvedActive === "delivery" ? "active" : ""}`}>
                            <button
                                type="button"
                                className="navbar-item"
                                aria-current={resolvedActive === "delivery" ? "page" : undefined}
                                onClick={() => navigate("/profile/delivery")}
                            >
                                Delivery Zones
                            </button>
                        </li>
                    </>
                ) : null}


                <li className="logout">
                    <button
                        type="button"
                        className="navbar-item"
                        onClick={handleLogout}
                    >
                        Sign Out
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default Navbar;

Navbar.propTypes = {
    active: PropTypes.string,
};
